import {Fragment, useContext} from 'react'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import LayoutGrid, {LayoutGridItem} from '@s-ui/react-layout-grid'
import MoleculeAccordion, {moleculeAccordionBehavior, MoleculeAccordionItem} from '@s-ui/react-molecule-accordion'
import IconAccordionCollapsed from '@adv-mt/mt-svg-icons/lib/ChevronDown.js'
import IconAccordionExpanded from '@adv-mt/mt-svg-icons/lib/ChevronUp.js'
import TitleBasic, {titleBasicSizes, titleBasicTags, titleBasicTextAlign} from '@adv-mt/mt-title-basic'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {faqQuestions, faqTracking} from './config.js'

const AccordionFaqs = () => {
  const {i18n} = useContext(Context)
  const {track} = useAnalyticsTrack()

  const onToggleFaqsTab = (event, {value, isExpanded}) => {
    if (isExpanded) {
      track({
        event: 'Landing IO Faq Expanded',
        data: {
          hit_information: faqTracking[value]
        }
      })
    }
  }

  return (
    <div className="mt-LandingInstantOffer-faqs">
      <TitleBasic
        as={titleBasicTags.h2}
        description={i18n.t('INSTANT_OFFER.LANDING.FAQS.WE_EXPLAIN_EVERYTHING')}
        size={titleBasicSizes.s}
        textAlign={titleBasicTextAlign.center}
        title={i18n.t('INSTANT_OFFER.LANDING.FAQS.IF_YOU_ARE_IN_DOUBT')}
      />
      <div className="mt-LandingInstantOffer-faqsAccordion">
        <MoleculeAccordion
          as={Fragment}
          headerIconCollapsed={<IconAccordionCollapsed size={ATOM_ICON_SIZES.medium} />}
          headerIconExpanded={<IconAccordionExpanded size={ATOM_ICON_SIZES.medium} />}
          behavior={moleculeAccordionBehavior.MULTIPLE}
          onChange={onToggleFaqsTab}
        >
          <LayoutGrid xxs={12}>
            {Object.keys(faqQuestions).map((faqKey, index) => (
              <LayoutGridItem>
                <MoleculeAccordionItem
                  as="div"
                  content={
                    <p className="mt-LandingInstantOffer-faqsAccordionText">
                      {i18n.t(i18n.t(faqQuestions[faqKey].answer))}
                    </p>
                  }
                  headerAs="h3"
                  key={faqKey}
                  label={i18n.t(faqQuestions[faqKey].question)}
                  value={index}
                />
              </LayoutGridItem>
            ))}
          </LayoutGrid>
        </MoleculeAccordion>
      </div>
    </div>
  )
}

AccordionFaqs.displayName = 'AccordionFaqs'

export default AccordionFaqs
